
export { default as list } from "./List";
export const name = "admin/voting";
export const options = {
  label: "Admin/Voting",
};
